"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleDateType = void 0;

var _react = require("react");

/**
 * PropType function that can be used with React components to validate objects
 * shaped like a "SimpleDate"
 *
 * type SimpleDate = {
 *   year: number;
 *   month: number;
 *   date: number;
 * };
 */
var SimpleDateType = _react.PropTypes.shape({
  year: _react.PropTypes.number.isRequired,
  month: _react.PropTypes.number.isRequired,
  date: _react.PropTypes.number.isRequired
});

exports.SimpleDateType = SimpleDateType;